// Module
var code = "<jst template-url=\"directives/studentComparisonGraph.jst\" using=\"stats\"></jst>\n\n";
// Exports
module.exports = code;